import React from "react";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import Body from "./Components/Body/Body";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ContactUs from "./Components/Contact us/ContactUs";
import BookRide from "./Components/Book Ride/BookRide";
import BlogsGallery from "./Components/Blogs Gallery/BlogsGallery";
import Whatsapp from './Components/Whatsapp/Whatsapp'
import BlogPage from "./Components/Blogs/BlogPage";
import AboutUs from "./Components/AboutUs/AboutUs";

const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: (
        <>
          <Header /><Whatsapp/> <Body /> <Footer /> 
        </>
      ),
    },
        {
      path: "/home",
      element: (
        <>
          <Header /> <Whatsapp/><Body /> <Footer />
        </>
      ),
    },

            {
      path: "/book-ride",
      element: (
        <>
          <Header /> <Whatsapp/><BookRide /> <Footer />
        </>
      ),
    },
                {
      path: "/blogs-gallery",
      element: (
        <>
          <Header /><Whatsapp/> <BlogPage /> <Footer />
        </>
      ),
    },

            {
      path: "/contact",
      element: (
        <>
          <Header /><Whatsapp/> <ContactUs /> <Footer />
        </>
      ),
    },

                {
      path: "/about-us",
      element: (
        <>
          <Header /><Whatsapp/> <AboutUs /> <Footer />
        </>
      ),
    },
  ]);

  return (
    <div>
    <RouterProvider router={router} />
    </div>
  );
};

export default App;
